import { render, staticRenderFns } from "./RicercaElementoField.vue?vue&type=template&id=f9fcfdca&scoped=true&"
import script from "./RicercaElementoField.vue?vue&type=script&lang=js&"
export * from "./RicercaElementoField.vue?vue&type=script&lang=js&"
import style0 from "./RicercaElementoField.vue?vue&type=style&index=0&id=f9fcfdca&lang=scss&scoped=true&"
import style1 from "./RicercaElementoField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fcfdca",
  null
  
)

export default component.exports